import React, { useEffect, useRef } from 'react'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax
import { useDispatch, useSelector } from 'react-redux'
import { changePopup } from '../../redux/slices/Map/map'
import { useLocation } from 'react-router-dom'
import * as rt from '../../config/routeType'

const markerHeight = 20
const markerRadius = 10
const linearOffset = 25

const popupOffsets = {
  top: [0, 0],
  'top-left': [0, 0],
  'top-right': [0, 0],
  bottom: [0, -markerHeight],
  'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
  'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
  left: [markerRadius, (markerHeight - markerRadius) * -1],
  right: [-markerRadius, (markerHeight - markerRadius) * -1],
}

const Popup = ({ children, lngLat, map }) => {
  let location = useLocation()
  const popupRef = useRef()
  const popup = useRef()
  const dispatch = useDispatch()

  const markerStatus = useSelector(state => state.mapState.marker)
  const popupOpen = useSelector(state => state.mapState.popupOpen)
  const rute = `/${rt.MANAGEMENT_TREE}/${rt.TREE}/${rt.REGISTER_TREE}`

  useEffect(() => {
    popup.current = new mapboxgl.Popup({
      closeButton: location.pathname !== rute,
      offset: popupOffsets,
      closeOnClick: false,
    })
      .setLngLat(lngLat)
      .setDOMContent(popupRef.current)
      .setMaxWidth('27em') // Set 'none' adapt to content
      .addTo(map)

    if (popup.current.isOpen()) {
      dispatch(changePopup(true))
    }

    if (markerStatus.draggable) {
      popup.current.remove()
    }
    popup.current.on('close', () => {
      dispatch(changePopup(false))
    })

    return () => {
      dispatch(changePopup(false))
      popup.current.remove()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, markerStatus.draggable, popupOpen])

  return (
    <div style={{ display: 'none' }}>
      <div ref={popupRef}>{children}</div>
    </div>
  )
}

export default React.memo(Popup)
